import React, { useState } from 'react';
import { Tabs, Tab, Paper } from '@material-ui/core';
import { ViewFBMUserAccounts } from './viewFBMUserAccounts';
import { CreateFBMUserAccount } from './createFBMUserAccount';
import { TabPanel, FBMAccountPicker } from '../../../shared';

const FBMUserAccounts = () => {
    let [selectedTab, setSelectedTab] = useState('0');
    let handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <FBMAccountPicker />
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewFBMUserAccounts_Tab" label="View" value="0" />
                <Tab id="CreateFBMUserAccount_Tab" label="Create" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index={'0'}>
                <ViewFBMUserAccounts />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index={'1'}>
                <CreateFBMUserAccount />
            </TabPanel>
        </Paper>
    );
};

export { FBMUserAccounts };
